import './app.css'
import 'babel-polyfill'

import React from 'react'
import { Provider } from 'react-redux'
import { IntlProvider } from 'react-intl-redux'
import initStore from './store'
import { initDefaultLocale } from './store/reducers/i18n'
import moment from 'moment'
import numeral from 'numeral'
import 'numeral/locales/ru'
import 'moment/locale/ru'

import Layout from './containers/Layout'
import wrapperContainer from './containers/Wrapper'
const ComposedLayout = wrapperContainer(Layout)
moment.locale('ru')
numeral.locale('ru')

export const store = initStore()
initDefaultLocale(store)


export default props => (
  <Provider store={store}>
    <IntlProvider>
      <ComposedLayout />
    </IntlProvider>
  </Provider>
)



// WEBPACK FOOTER //
// ./src/App.jsx